import { render, staticRenderFns } from "./ShortcutKeys.vue?vue&type=template&id=41fe9d96&scoped=true&lang=pug"
import script from "./ShortcutKeys.vue?vue&type=script&lang=ts"
export * from "./ShortcutKeys.vue?vue&type=script&lang=ts"
import style0 from "./ShortcutKeys.vue?vue&type=style&index=0&id=41fe9d96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fe9d96",
  null
  
)

export default component.exports